import React from "react";
import {useActions} from "../actions";
import * as EstimatorActions from "../actions/estimator";
import * as EstimationActions from "../actions/estimation";
import {isDebug} from "../utils/commonUtils";


type CarrierStrategyProps = { strategyId: number, carrierId: number };

const useGetAllocations = (carrierId: number, strategyId: number) => {
    const debugMode = isDebug();
    const estimatorActions = useActions(EstimatorActions);
    const [estimatorDataId, setEstimatorDataId] = React.useState<any | null>();
    const estimationActions = useActions(EstimationActions);
    const [allocationQuestion, setAllocationQuestion] = React.useState({});

    React.useEffect(() => {
        const getEstimatorDataFromApi = async (query: Partial<CarrierStrategyProps>) => {
            if (query.carrierId && query.strategyId) {
                const res = await estimatorActions.getEstimatorDetails(query);
                if (!!res) {
                    setEstimatorDataId(res.id);
                }
            }
        }
        if (!estimatorDataId && strategyId && carrierId) {
            debugMode && console.info('Fetching estimator data for strategyId:', strategyId, 'and carrierId:', carrierId);
            const query: Partial<CarrierStrategyProps> = {carrierId, strategyId};
            getEstimatorDataFromApi(query).then(() => debugMode && console.info('Estimator data fetched successfully'));
        } else if (estimatorDataId) {
            debugMode && console.info(estimatorDataId, 'Estimator data already exists for strategyId:', strategyId, 'and carrierId:', carrierId);
        }
    }, [strategyId, strategyId]);

    React.useEffect(() => {
        (async () => {
            if (estimatorDataId) {
                debugMode && console.info('Fetching allocation questions for estimatorDataId:', estimatorDataId, 'and carrierId:', carrierId);
                const res = await estimationActions.getAllocationQuestions({
                    estimatorId: estimatorDataId,
                    carrierId: carrierId
                });
                if (res) {
                    const values = {};
                    res.forEach((fields: any) => {
                        values[fields.code] = fields;
                    });
                    setAllocationQuestion(values);
                }
            } else {
                debugMode && console.info('No estimatorDataId available, skipping allocation questions fetch');
            }
        })();
    }, [estimatorDataId]);

    return allocationQuestion
};

export default useGetAllocations;